(function () {
  function money(cents) {
    var v = (cents / 100).toFixed(2).replace(/\.00$/, '');
    var parts = v.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return '\u20B9' + parts.join('.');
  }

  function init(root) {
    if (!root || root.dataset.kslpReady === '1') return;
    root.dataset.kslpReady = '1';

    var form = root.querySelector('[data-kslp-form]');
    var idInput = root.querySelector('[data-kslp-id]');
    var radios = root.querySelectorAll('[data-kslp-radio]');
    var priceEl = root.querySelector('[data-kslp-price]');
    var btn = root.querySelector('[data-kslp-atc]');
    var sticky = document.querySelector('[data-kslp-sticky]');
    var sName = sticky && sticky.querySelector('[data-kslp-sticky-name]');
    var sPrice = sticky && sticky.querySelector('[data-kslp-sticky-price]');
    var sBtn = sticky && sticky.querySelector('[data-kslp-sticky-btn]');
    if (!form || !idInput) return;

    function apply(radio) {
      if (!radio) return;
      var id = radio.value;
      var price = parseInt(radio.dataset.price, 10);
      var name = radio.dataset.name || '';
      var available = radio.dataset.available === 'true';

      idInput.value = id;
      if (priceEl) priceEl.textContent = money(price);
      if (btn) {
        btn.disabled = !available;
        btn.textContent = available ? (btn.dataset.label || 'Continue') : 'Sold out';
      }
      if (sName) sName.textContent = name;
      if (sPrice) sPrice.textContent = money(price);

      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', id);
        window.history.replaceState({}, '', url.toString());
      } catch (e) {}
    }

    Array.prototype.forEach.call(radios, function (r) {
      r.addEventListener('change', function () { apply(r); });
    });

    var checked = root.querySelector('[data-kslp-radio]:checked');
    if (checked) apply(checked);

    if (sBtn) {
      sBtn.addEventListener('click', function () {
        if (typeof form.requestSubmit === 'function') form.requestSubmit();
        else form.submit();
      });
    }

    if (sticky && 'IntersectionObserver' in window) {
      document.body.classList.add('kslp-body');
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          sticky.classList.toggle('is-on', !en.isIntersecting && en.boundingClientRect.top < 0);
        });
      }, { threshold: 0 });
      io.observe(root);
    }
  }

  function boot() {
    document.querySelectorAll('[data-kslp-choose]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
